import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { bentoniteMinerals } from "../Data";
import BreadCrumb from "../Components/BreadCrumb";
import MineralIntro from "../Components/MineralIntro";
import ContactSection from "../Components/ContactSection";
import MineralSpecifications from "../Components/MineralSpecifications";
import MineralTabs from "../Components/MineralTabs";
import MineralFaqs from "../Components/MineralFaqs";
import MineralStats from "../Components/MineralStats";
import MineralCta from "../Components/MineralCta";
import OtherMinerals from "../Components/OtherMinerals";
import NotFound from "./NotFound";
import organizationSchema from "../Schema/OrganizationSchema";
import SchemaMarkup from "../Components/SchemaMarkup";
import productSchema from "../Schema/ProductSchema";
import breadcrumbSchema from "../Schema/BreadcrumbSchema";
import webPageSchema from "../Schema/WebPageSchema";

const BentoniteDetail=()=>{
    const { slug } = useParams();
  const bentoniteMineral = bentoniteMinerals.find(item => item.url === slug);

  useEffect(() => {
    if (!bentoniteMineral) return;
    document.title = bentoniteMineral.metaTitle;

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) metaDesc.setAttribute("content", bentoniteMineral.metaDescription);

      let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }

  canonical.setAttribute(
    "href",
    `https://irisimpulse.com/bentonite-minerals/${slug}`
  );

   const ogTitle = document.querySelector("meta[property='og:title']");
  if (ogTitle) {
    ogTitle.setAttribute(
      "content",
    bentoniteMineral.metaTitle
    );
  }

    const ogDesc = document.querySelector("meta[property='og:description']");
  if (ogDesc) {
    ogDesc.setAttribute(
      "content",
     bentoniteMineral.metaDescription
    );
  }

  const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content",  `https://irisimpulse.com/bentonite-minerals/${slug}`);
  }

    const ogImage = document.querySelector("meta[property='og:image']");
  if (ogImage) {
    ogImage.setAttribute(
      "content",
      (`https://irisimpulse.com${bentoniteMineral.ogImage}`)
    );
  }

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
  if (twitterTitle) {
    twitterTitle.setAttribute(
      "content",
     bentoniteMineral.metaTitle
    );
  }

    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
  );
  if (twitterDesc) {
    twitterDesc.setAttribute(
      "content",
    bentoniteMineral.metaDescription
    );
  }

    const twitterImage = document.querySelector("meta[name='twitter:image']");
  if (twitterImage) {
    twitterImage.setAttribute(
      "content",
      (`https://irisimpulse.com${bentoniteMineral.ogImage}`)
    );
  }

}, [bentoniteMineral, slug]);

  if (!bentoniteMineral) return <NotFound />;

  const organizationData = organizationSchema();
  const breadcrumbData = breadcrumbSchema({
  items: [
    {
      name: "Home",
      url: "https://irisimpulse.com/",
    },
    {
      name: "Bentonite Performance Minerals",
      url: "https://irisimpulse.com/bentonite-minerals",
    },
    {
      name: bentoniteMineral.emailTitle,
    },
  ],
});
const webPageData = webPageSchema({
  url: `https://irisimpulse.com/bentonite-minerals/${bentoniteMineral.url}`,
  title: bentoniteMineral.emailTitle,
  description:bentoniteMineral.metaDescription,
  image: `https://irisimpulse.com${bentoniteMineral.ogImage}`,
});
const productData = productSchema({
  name: bentoniteMineral.emailTitle,
  description: bentoniteMineral.metaDescription,
  image: `https://irisimpulse.com${bentoniteMineral.ogImage}`,
  url: `https://irisimpulse.com/bentonite-minerals/${bentoniteMineral.url}`,
});

    return(
        <>

        <SchemaMarkup data={organizationData} />
        <SchemaMarkup data={breadcrumbData} />
        <SchemaMarkup data={webPageData} />
        <SchemaMarkup data={productData} />


        <React.Fragment key={slug}>
               <BreadCrumb
  title={`${bentoniteMineral.breadcrumbTitle}`}
  bgImage={bentoniteMineral.bgImg} 
  youtubeLink="https://www.youtube.com/@IrisImpulseIndia"
/>

        {/**INTRODUCTION SECTION */}
        <MineralIntro
        heading={bentoniteMineral.introHeading}
        desc={bentoniteMineral.introPara}
        img={bentoniteMineral.introImg}
        mineral={bentoniteMineral}
        />

        {/**TABS SECTION */}
        <MineralTabs
  data={bentoniteMineral.tabsData}
/>

        <MineralSpecifications
        heading={bentoniteMineral.specHeading}
        desc={bentoniteMineral.specDesc}
        />

        {/**PACKING & SUPPLY OPTION SECTION */}
        <MineralStats
        images={bentoniteMineral.packingImages}
          heading1={bentoniteMineral.packingHeading}
          desc1={bentoniteMineral.packingDesc}
          heading2={bentoniteMineral.statsHeading}
          desc2={bentoniteMineral.statsDesc}
          stats={bentoniteMineral.stats}
        />

        {/**FAQS SECTION */}
        <MineralFaqs
          heading={bentoniteMineral.faqsHeading}
          description={bentoniteMineral.faqsDesc}
          faqs={bentoniteMineral.faqs}
        />

        {/**CTA SECTION */}
        <MineralCta
        heading={bentoniteMineral.ctaHeading}
        desc={bentoniteMineral.ctaDesc}
        />

        {/**OTHER MINERALS SECTION */}
        <OtherMinerals
  heading="Explore More High-Quality Bentonite Products"
  minerals={bentoniteMinerals}
  currentMineralId={bentoniteMineral.id}
  basePath="/bentonite-minerals"
/>

 {/**CONTACT FORM SECTION */}
    <ContactSection />
        </React.Fragment>
        </>
    )
}
export default BentoniteDetail;